import React, { FC } from 'react'

import { LoaderPreview, PaymentsPreview } from 'features/OrderPreview/ui'
import { usePaymentFormController } from 'features/Booking/model/hooks/usePaymentFormController'
import { PaymentMethodName } from 'entities/payments/model'
import { Autocomplete } from 'shared/components/Autocomplete'
import { Input } from 'shared/components/Input'
import { Button } from 'shared/components/Button'
import { Label } from 'shared/components/Input/style'
import { Flex } from 'shared/components/Flex'

interface PaymentFormProps {
    isPreview: boolean
}

export const PaymentForm: FC<PaymentFormProps> = ({ isPreview }) => {
    const {
        isOnlinePayment,
        isLoading,
        isPaid,
        isButtonDisabled,
        redirectUrl,

        amount,
        onEditAmount,

        certificate,
        currentCertificateBalance,
        certificatesOptions,
        onChangeCertificate,

        currentPayments,
        paymentTypeOption,
        paymentType,
        paymentTypesOptions,
        onChangePaymentType,
        paymentCallbacks,

        comment,
        onChangeComment,

        onGoNext,
        fillAccountPaymentDetails,

        onDeletePayment,
    } = usePaymentFormController()

    return (
        <div className='content'>
            <PaymentsPreview
                payments={currentPayments}
                redirectUrl={redirectUrl}
                paymentCallbacks={isPreview ? undefined : paymentCallbacks}
                isOpenByDefault={isPreview}
                allowDeleting={!isPreview}
                onDeletePayment={onDeletePayment}
            />

            {isPaid ? (
                <Button disabled onClick={onGoNext}>
                    Оплачено
                </Button>
            ) : (
                <>
                    {!isPreview && (
                        <>
                            <Autocomplete
                                value={paymentTypeOption ?? null}
                                onChange={onChangePaymentType}
                                options={paymentTypesOptions}
                                label='Способ оплаты'
                                placeholder='Выберете способ оплаты'
                                required
                            />
                            {(isOnlinePayment ||
                                paymentType === PaymentMethodName.Cash ||
                                paymentType === PaymentMethodName.Account) && (
                                <Input
                                    value={amount}
                                    onChange={onEditAmount}
                                    label='Сумма'
                                    placeholder='Введите сумму'
                                    required
                                />
                            )}
                            {paymentType === PaymentMethodName.Certificate && (
                                <>
                                    <Autocomplete
                                        value={certificate ?? null}
                                        onChange={onChangeCertificate}
                                        options={certificatesOptions}
                                        label='Сертификат'
                                        placeholder='Введите название...'
                                        required
                                    />
                                    <Label>
                                        Баланс сертификата: ₽
                                        {currentCertificateBalance}
                                    </Label>
                                </>
                            )}
                            <Input
                                label='Комментарий'
                                value={comment}
                                onChange={onChangeComment}
                            />
                            {paymentType === PaymentMethodName.Account && (
                                <Button
                                    disabled={isButtonDisabled}
                                    onClick={fillAccountPaymentDetails}
                                >
                                    Составить счет на оплату
                                </Button>
                            )}
                            {paymentType !== PaymentMethodName.Account && (
                                <Button
                                    disabled={isButtonDisabled}
                                    onClick={onGoNext}
                                >
                                    Внести оплату
                                </Button>
                            )}
                        </>
                    )}
                </>
            )}
            {isLoading && (
                <Flex padding={10}>
                    <LoaderPreview />
                </Flex>
            )}
        </div>
    )
}
